export async function GetCSRFToken(): Promise<{ requestToken: string }> {
  return (await fetch("/csrf/token").then((response) => response.json())) as Promise<{ requestToken: string }>;
}
